export const myTasksEn = {
  expandDoneTasks: 'Expand',
  collapseDoneTasks: 'Collapse',
  filters: 'Filters',
  resetSort: 'Reset sort',
  columnsSettings: 'Columns setting',
  columnsSettingsPromoMessage: 'You can now configure the columns here!',
  understood: 'Understood',
  columns: {
    location: 'Location',
    stickers: 'Stickers'
  },
  orderBy: {
    taskName: 'By name'
  },
  columnOrder: {
    favoritesFirst: 'Favorites first',
    favoritesLast: 'Favorites last'
  }
}

export const myTasksRu: typeof myTasksEn = {
  expandDoneTasks: 'Развернуть',
  collapseDoneTasks: 'Свернуть',
  filters: 'Фильтры',
  resetSort: 'Сбросить сортировку',
  columnsSettings: 'Настройка столбцов',
  columnsSettingsPromoMessage: 'Настроить столбцы теперь можно здесь!',
  understood: 'Понятно',
  columns: {
    location: 'Расположение',
    stickers: 'Стикеры'
  },
  orderBy: {
    taskName: 'По названию'
  },
  columnOrder: {
    favoritesFirst: 'Избранные в начале',
    favoritesLast: 'Избранные в конце'
  }
}
